import Tween from "tween.ts";
import Animation from "../Animation";
import Point from "../../entities/Point";


export default class DrawPointAnim extends Animation {
  constructor(point: Point, cb: () => void) {
    super();
    new Tween.Tween(point)
      .to({ scale: 1 }, 300)
      .easing(Tween.Easing.Elastic.Out)
      .onComplete(() => cb())
      .start()
  }
}